// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13y_g","badges":"styles_badges__7kJon"};